module.exports = __webpack_public_path__ + "static/media/LocalSimCard.ab0915a1.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/LocalSimCard.svg
// module id = 2603
// module chunks = 0